import { render } from "./Form1.vue?vue&type=template&id=7b1a9630"
import script from "./Form1.vue?vue&type=script&lang=js"
export * from "./Form1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__